import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from 'app/loader.service';
import { HubService } from 'app/hub.service';
import { ApiService } from 'app/api.service';
import { DatatableComponent } from '@swimlane/ngx-datatable/src/components/datatable.component';
import * as moment from 'moment';
import * as _ from 'underscore';
import { savedList } from './saved-list'
declare var alertify: any;

@Component({
  selector: 'app-five-k-board',
  templateUrl: './five-k-board.component.html',
  styleUrls: ['./five-k-board.component.scss']
})
export class FiveKBoardComponent implements OnInit {

  private Parse: any = require('parse');
  fiveKSessionsTrainingList: any = [];
  fiveKSessionsList: any = savedList;
  fiveKSessionsCount: number = 0;
  listCutoff: number = 50;
  loggedIn: any = false;

  @ViewChild('table') table: DatatableComponent;

  constructor(
    // private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private hubService: HubService,
    public apiService: ApiService
  ) {
    // this.loaderService.setLoading();
    this.loaderService.setLoaded();
    // this.updateTable();
  }

  ngOnInit() {
    // If the user is logged in show the results, otherwise show a login notice
    if(this.Parse.User.current()){
      this.loggedIn = true;
      this.updateTable();
    }else{
      this.loggedIn = false;
    }
    
  }

  // Update the table
  private updateTable() {
    this.getfiveKTrainingList();
  }

  private getfiveKTrainingList() {

    let where: any = {
      workout: {
        __type: "Pointer",
        className: "Workout",
        objectId: "wo-5k-distance" // "wo-herne-hill-5k" // 
      },
      createdAt: {
        $gte: {
          iso: "2020-05-12",
          __type: "Date"
        },
        $lte: {
          iso: "2020-05-26",
          __type: "Date"
        }
      },
      _rperm : { "$in" : ["*"]}
    };

    where = JSON.stringify(where);

    // make the api call
    this.hubService.getResource('RideSessionTraining', where, 2000, null, null, null)
      .subscribe(
        response => {
          this.fiveKSessionsCount = response.length; // how many results do we have
          this.getfiveKSessionList(response); // get our RideSession Entries
        },
        error => {
          alertify.error(error);
        },
        () => {
          console.log("RideSessionTraining query Completed");
          console.log("this.fiveKSessionsList: " + JSON.stringify(this.fiveKSessionsList));
          console.log(JSON.stringify(this.fiveKSessionsList));
        }
      );
  }

  private getfiveKSessionList(trainingList) {

    for (let i = 0; i < trainingList.length; i++) {

      let where = {
        "training": {
          "__type": "Pointer",
          "className": "RideSessionTraining",
          "objectId": trainingList[i].objectId
        }
      }
      let include = ['user', 'sessionSummary', 'userPerformanceState'];
      this.hubService.getResource('RideSession', where, 1, null, null, include).subscribe(
        rideResponse => {
          rideResponse['sessionSummary'] = {};
          // console.log("rideResponse.result: " + JSON.stringify(rideResponse))
          if(rideResponse[0].userPerformanceState){
            rideResponse[0]['sessionSummary']['pkg'] = rideResponse[0].sessionSummary.powerAvg / rideResponse[0].userPerformanceState.weight;
          }else{
            rideResponse[0]['sessionSummary']['pkg'] = 0;
          }
          
          if(rideResponse[0]['sessionSummary']['distance'] > 4999){
            this.fiveKSessionsList.push(rideResponse[0]);
            this.fiveKSessionsList = _.sortBy(this.fiveKSessionsList, function(o:any) {
              return o.sessionSummary.time;
            })
          }
          
        },
        error => {
          alertify.error(error);
        });

    }

  }

  // Navigate to selected session when the table row is clicked
  onActivate(event) {
    if (event.type == 'click') {
      let target = event.event.target.tagName.toLowerCase();
      if (target != 'label' && target != 'input') {
        console.log(JSON.stringify(this.fiveKSessionsList));
        this.router.navigate(['/session', event.row.objectId])
      }
    }
  }


}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/five-k-board/five-k-board.component.ts